import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const RowWrapper = styled.div<{
  verticalSpacing: { mobile: number; tablet: number; desktop: number };
  fullWidth: { mobile: boolean; tablet: boolean; desktop: boolean };
  maxWidth?: number;
}>`
  --margin: ${(props) => `${props.verticalSpacing.desktop}px`};
  --padding: ${(props) => `${props.fullWidth?.desktop ? '0' : '16px'}`};

  @media (${mediaQuery.tablet}) {
    --margin: ${(props) => `${props.verticalSpacing.tablet}px`};
    --padding: ${(props) => `${props.fullWidth?.tablet ? '0' : '16px'}`};
  }

  @media (${mediaQuery.mobile}) {
    --margin: ${(props) => `${props.verticalSpacing.mobile}px`};
    --padding: ${(props) => `${props.fullWidth?.mobile ? '0' : '16px'}`};
  }

  width: 100%;
  max-width: ${(props) =>
    !props.fullWidth?.desktop && props.maxWidth
      ? `calc(${props.maxWidth}px + var(--padding) * 2)`
      : `100%`};
  margin: var(--margin) auto 0;
  padding: 0 var(--padding);

  @media (${mediaQuery.tablet}) {
    max-width: 100%;
  }
`;
